import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { getConfirmTokenCall, postAcceptInvitationCall } from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getConfirmTokenCall.saga,
  postAcceptInvitationCall.saga,
];

export function* invitationSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
